import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BedtimeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bedtime"}/>
}
